module.exports = __webpack_public_path__ + "img/exclamation-round-red.9be687d2.svg";